<template>
  <div class="formulate-input">
    <label class="formulate-input-label mb-2" v-if="label || required">
      <small v-if="required" class="text-danger">*</small>
      {{ label || 'Quadro:' }}
    </label>
    <NxInput
      name="quadro"
      type="select"
      :label="(!label && !required) ? 'Quadro:' : ' '"
      :option-groups="listOptions"
      placeholder="Selecione o Quadro"
      :state="state"
      @update:value="handleValueUpdate"
    ></NxInput>
  </div>
</template>
<script>
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import NxInput from '../inputs/NxInput.vue'

import { JWTService } from '@/shared/services/jwt'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'NxSelectQuadro',
  mixins: [useReactiveModelMixin('value')],
  components: {
    NxInput
  },
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isAdmin: false,
      onlyShowActive: false,
      listOptions: {},
      selected: null
    }
  },
  created () {
    this.onlyShowActive = this.onlyActive
    this.checkIsAdmin()
    this.onLoadBoards()
  },
  methods: {
    onLoadBoards () {
      BoardRepository.Board_GetAll()
        .then((res) => {
          let activeOptions = this.filterAndReduce(res, (x) => !x.arquivado)
          let filedOptions = this.filterAndReduce(res, (x) => x.arquivado)

          let options = []

          if (this.onlyShowActive) {
            options = {
              Ativos: activeOptions
            }
          } else {
            options = {
              Ativos: activeOptions,
              Arquivados: filedOptions
            }
          }

          this.listOptions = options
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Quadros', 'Erro')
          console.error(err)
        })
    },
    filterAndReduce (res, condition) {
      return res.data.content
        .filter((x) => x.id != null && condition(x))
        .reduce((acc, x) => {
          acc[x.id] = x.nome
          return acc
        }, {})
    },
    checkIsAdmin () {
      this.isAdmin = JWTService.GetRoles().some(
        (role) => role === Roles.ADMINISTRADOR
      )
      if (!this.isAdmin) this.onlyShowActive = true
    },
    handleValueUpdate (val) {
      this.localValue = val
      this.$emit('update:value', val)
      // Limpa o estado quando um valor é selecionado
      if (val && this.state === false) {
        this.$emit('clear-state')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectQuadro.vue